// extracted by mini-css-extract-plugin
export default {"documentViewer":"CustomWebViewer_documentViewer__CkVd1"};